export const languageMap = {
    "af": "Afrikaans",
    "ar": "Arabic",
    "hy": "Armenian",
    "az": "Azerbaijani",
    "be": "Belarusian",
    "bs": "Bosnian",
    "bg": "Bulgarian",
    "ca": "Catalan",
    "zh-CH": "Chinese",
    "zh-TW": "Chinese Traditional",
    "hr": "Croatian",
    "cs": "Czech",
    "da": "Danish",
    "nl": "Dutch",
    "en": "English",
    "et": "Estonian",
    "fi": "Finnish",
    "fr": "French",
    "gl": "Galician",
    "de": "German",
    "el": "Greek",
    "he": "Hebrew",
    "hi": "Hindi",
    "hu": "Hungarian",
    "is": "Icelandic",
    "id": "Indonesian",
    "it": "Italian",
    "ja": "Japanese",
    "kn": "Kannada",
    "kk": "Kazakh",
    "ko": "Korean",
    "lv": "Latvian",
    "lt": "Lithuanian",
    "mk": "Macedonian",
    "ms": "Malay",
    "mr": "Marathi",
    "mi": "Maori",
    "ne": "Nepali",
    "no": "Norwegian",
    "fa": "Persian",
    "pl": "Polish",
    "pt": "Portuguese",
    "ro": "Romanian",
    "ru": "Russian",
    "sr": "Serbian",
    "sk": "Slovak",
    "sl": "Slovenian",
    "es": "Spanish",
    "sw": "Swahili",
    "sv": "Swedish",
    "tl": "Tagalog",
    "ta": "Tamil",
    "th": "Thai",
    "tr": "Turkish",
    "uk": "Ukrainian",
    "ur": "Urdu",
    "vi": "Vietnamese",
    "cy": "Welsh"
  } as const;
  
  export type LanguageCode = keyof typeof languageMap;

  /**
   * Languages offered in the import ("Add a book") and Discover pickers.
   * MiMo narration only supports English + Chinese, so the pickers are limited
   * to these two (learners alternate between them). The wider `languageMap`
   * above is retained for labeling pre-existing books. `zh-CN` is the standard
   * Simplified-Chinese tag the backend accepts (it normalizes the primary
   * subtag `zh` for translation + TTS); the legacy `zh-CH` entry in
   * `languageMap` is a typo kept only for old books.
   */
  export const LEARNING_LANGUAGES: Array<[string, string]> = [
    ["en", "English"],
    ["zh-CN", "Chinese (Simplified)"],
  ];
